import { EMPTY_VALUE } from "./display";

/**
 * The three languages an enterprise can have.
 *
 * Constrained, unlike `country`: the Enterprise entity types the column
 * `"es" | "en" | "fr"`, and those are exactly the languages AIA Sign holds
 * contract templates for. The stored value is the lowercase code; only the label
 * is ever shown.
 */
export const LANGUAGE_LABELS: Record<string, string> = {
  fr: "Français",
  en: "Anglais",
  es: "Espagnol",
};

/** Ready-made options for a filter or form select, in the display order used everywhere. */
export const LANGUAGE_OPTIONS = Object.entries(LANGUAGE_LABELS).map(
  ([value, label]) => ({ value, label }),
);

/**
 * Label for a stored language code.
 *
 * An unrecognised code is returned as-is rather than hidden: it would mean the
 * column holds something the entity does not allow, which is worth seeing.
 */
export const formatLanguage = (
  code: string | null | undefined,
): string => {
  if (!code) return EMPTY_VALUE;
  return LANGUAGE_LABELS[code.trim().toLowerCase()] ?? code;
};
